import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

export const StoryBook = () => {
  const navigate = useNavigate();
  return (
    <div style={{ position: "relative" }}>
      <iframe className="storybook" src="/storybook-static/index.html" />;
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
        onClick={() => signOut(auth)}
      >
        Logout
      </button>
      <button
        style={{
          position: "absolute",
          top: 10,
          right: 80,
        }}
        onClick={() => navigate("/test")}
      >
        Tests
      </button>
    </div>
  );
};
